import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/views/app/app.component';
import { routes } from './app/routes/routes';
import { provideRouter, withComponentInputBinding } from '@angular/router';

// Bootstrap the application
bootstrapApplication(AppComponent, {
	providers: [provideAnimations(), provideRouter(routes, withComponentInputBinding()), provideAnimations()],
}).catch(err => console.error(err));
